import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { TiktokShopProvider } from '@/tiktok-platform/context/TiktokShopContext';
import TiktokShopTopBar from '@/tiktok-platform/layout/TiktokShopTopBar';
import TiktokNoticeDrawerHost from '@/tiktok-platform/components/TiktokNoticeDrawerHost';
import { TIKTOK_SHOP_SWITCH_TOAST_KEY } from '@/tiktok-platform/constants/tiktokRoutes';
import { showToast } from '@/utils/toast';
import '@/styles/tiktok-platform/tiktok-platform.css';
import '@/styles/tiktok-platform/tiktok-product-ops.css';

/**
 * 发布 / 编辑产品专用布局：保留顶栏店铺上下文，无左侧菜单。
 */
export default function TiktokProductEditorLayout() {
  useEffect(() => {
    try {
      const raw = sessionStorage.getItem(TIKTOK_SHOP_SWITCH_TOAST_KEY);
      if (!raw) return;
      sessionStorage.removeItem(TIKTOK_SHOP_SWITCH_TOAST_KEY);
      const payload = JSON.parse(raw);
      if (payload?.message) {
        showToast(payload.message, payload.type || 'success');
      }
    } catch {
      sessionStorage.removeItem(TIKTOK_SHOP_SWITCH_TOAST_KEY);
    }
  }, []);

  return (
    <TiktokShopProvider>
      <div
        className="tiktok-platform tiktok-platform--editor"
        data-testid="tiktok-product-editor-layout"
      >
        <TiktokShopTopBar />
        <TiktokNoticeDrawerHost />
        <div className="tiktok-platform__body tiktok-platform__body--editor">
          <main className="tiktok-platform__main tiktok-platform__main--product-ops tiktok-platform__main--editor">
            <Outlet />
          </main>
        </div>
      </div>
    </TiktokShopProvider>
  );
}
